import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	workspaces: [],
	currentWorkspace: null,
	loading: false,
	error: null,
};

const workspaceSlice = createSlice({
	name: "workspace",
	initialState,
	reducers: {
		setWorkspaces: (state, action) => {
			state.workspaces = action.payload;
			state.loading = false;
		},
		setCurrentWorkspace: (state, action) => {
			state.currentWorkspace = action.payload;
		},
		addWorkspace: (state, action) => {
			state.workspaces.push(action.payload);
		},
		updateWorkspace: (state, action) => {
			const index = state.workspaces.findIndex(
				(w) => w.id === action.payload.id,
			);
			if (index !== -1) {
				state.workspaces[index] = {
					...state.workspaces[index],
					...action.payload,
				};
			}
			if (state.currentWorkspace?.id === action.payload.id) {
				state.currentWorkspace = {
					...state.currentWorkspace,
					...action.payload,
				};
			}
		},
		deleteWorkspace: (state, action) => {
			state.workspaces = state.workspaces.filter(
				(w) => w.id !== action.payload,
			);
			if (state.currentWorkspace?.id === action.payload) {
				state.currentWorkspace = null;
			}
		},
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
		setError: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const {
	setWorkspaces,
	setCurrentWorkspace,
	addWorkspace,
	updateWorkspace,
	deleteWorkspace,
	setLoading,
	setError,
} = workspaceSlice.actions;

export default workspaceSlice.reducer;
